<template>
  <section>
    <section class="trading-account-wrapper">
      <Select
        v-if="accountList.length > 0"
        :styleConfig="{
          borderRadius: '40px',
          boxShadow: 'inset 1px 1px 4px 0 rgba(184, 184, 184, 0.5)',
          padding: '0px 30px',
          border: 'none',
          fontFamily: 'Oblivian'
        }"
        :options="accountList"
        :withPrefix="true"
        @input="onAccountChange"
        :value="participantId"
      />
    </section>
    <section class="money-card-wrapper" v-if="accountInfo">
      <MoneyCard :image="depositImg" :name="this.$t('common.totalDeposit')" :amount="accountInfo.totalDeposit" />
      <div class="v-divide"></div>
      <MoneyCard :image="balance" :name="this.$t('common.creditBalance')" :amount="accountInfo.remainingCredit" />
      <div class="v-divide"></div>
      <MoneyCard :image="credit" :name="this.$t('common.receivedCredit')" :amount="accountInfo.totalCreditAwarded" />
    </section>
    <section class="exhange-table-wrapper" v-if="accountInfo">
      <ExchangeTable
        class="exchange-table-wrapper"
        @redeem="redeemAction"
        :remainingLots="accountInfo.remainingLots"
        :remainingCredit="accountInfo.remainingCredit"
      />
      <RedeemAndRemainingTable
        class="reedem-and-remaining-table-wrapper"
        :remainingLots="accountInfo.remainingLots"
        :lotsConverted="accountInfo.lotsConverted"
        :creditConverted="accountInfo.creditConverted"
      />
    </section>
    <section class="tradeinfo-table-wrapper" v-if="accountLogs">
      <TradeInfoTable :tableData="accountLogs" :participantId="participantId" />
    </section>
    <section class="message-wrapper" v-else>
      <p>{{ $t('common.noAccountParticipateCampaign') }}</p>
    </section>
  </section>
</template>

<script>
import MoneyCard from './MoneyCard.vue';
import ExchangeTable from './ExchangeTable.vue';
import RedeemAndRemainingTable from './RedeemAndRemainingTable.vue';
import TradeInfoTable from './TradeInfoTable.vue';
import Select from '@/components/interact/Select.vue';
import { REDEPOSIT_BONUS_ID } from '@/constants/promotion';
import { apiActivedAccounts, apiAccountInfo, apiCreditToBalance, apiAccountLogs } from '@/resource';
import { rsa } from '@/util/encrypt';

export default {
  name: 'StatusOverview',
  components: {
    MoneyCard,
    ExchangeTable,
    RedeemAndRemainingTable,
    TradeInfoTable,
    Select
  },
  data() {
    return {
      depositImg: require('@/assets/images/icon/cnDepositBonus/deposit.png'),
      balance: require('@/assets/images/icon/cnDepositBonus/balance.png'),
      credit: require('@/assets/images/icon/cnDepositBonus/credit.png'),
      accountInfo: null,
      activeAccounts: null,
      accountList: [],
      participantId: null,
      accountLogs: null
    };
  },
  mounted() {
    this.getActiveAccounts();
  },
  computed: {
    campaignID() {
      let campaign = this.$store.state.promotion.eligibleCampaigns.find(c => c.campaignType === 'RE_DEPOSIT_BONUS');
      return campaign ? campaign.id : null;
    }
  },
  watch: {
    participantId(val) {
      this.getAccountInfo();
      this.getAccountLogs();
    },
    activeAccounts(val) {
      this.accountList =
        this.activeAccounts.length > 0
          ? this.activeAccounts.map(f => {
              return {
                label: `${f.accountNo}-${f.accountType}`,
                value: f.participantId
              };
            })
          : [];
      this.participantId = this.accountList[0].value;
    }
  },
  methods: {
    getActiveAccounts() {
      apiActivedAccounts(this.campaignID)
        .then(resp => {
          this.activeAccounts = resp.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getAccountInfo() {
      apiAccountInfo({ participantId: this.participantId, depositCampaignId: REDEPOSIT_BONUS_ID })
        .then(resp => {
          this.accountInfo = resp.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getAccountLogs() {
      apiAccountLogs({ participantId: this.participantId })
        .then(resp => {
          this.accountLogs = resp.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    redeemAction(val) {
      let body = Object.assign({ participantId: this.participantId }, val);
      let reqBody = rsa(JSON.stringify(body));
      apiCreditToBalance(reqBody)
        .then(res => {
          if (res.data.data) {
            this.getAccountInfo();
            this.$message({
              message: this.$t('common.field.successful'),
              type: 'success'
            });
          }
        })
        .catch(err => {
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error'
          });
        });
    },
    onAccountChange(val) {
      this.participantId = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.money-card-wrapper {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-top: 83px;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin-top: 30px;
    flex-wrap: wrap;
  }
}
.v-divide {
  width: 2px;
  border-left: 2px solid #efefef;
  margin: 0 38px;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    display: none;
  }
}
.exhange-table-wrapper {
  display: flex;
  padding: 15px;
  width: 80%;
  margin: auto;
  & .exhange-table-wrapper {
    flex-grow: 1;
  }

  & .reedem-and-remaining-table-wrapper {
    flex-grow: 1.8;
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    flex-wrap: wrap;
  }
}
.tradeinfo-table-wrapper {
  padding: 0 30px;
  width: 80%;
  margin: auto;
}

.trading-account-wrapper {
  position: absolute;
  right: 0px;
  top: 15px;
  width: auto;
  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    right: 0;
    top: -173px;
    width: 95%;
  }

  @media (max-width: '1100px') {
    left: 50%;
    transform: translate(-50%, 0);
    top: 90px;
  }
}

.message-wrapper {
  margin: auto;
  padding: 100px 0;
  font-size: 21px;
  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin-top: 30px;
  }
}
</style>
